import Vue from 'vue'
import VueMeta from 'vue-meta'
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'

import App from './App.vue'
import router from './router'

Vue.use(Buefy)
Vue.use(VueMeta)
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
